import { defaultHttpClient } from 'shared/src/api/httpClient';
import type { Address, AddressUpsertParams } from './types';

type PostAddressResponse = {
  address: Address;
};

/**
 * - 배송지 추가
 * - `POST /members/me/addresses/`
 */
export const postAddress = (params: AddressUpsertParams) => {
  return defaultHttpClient
    .request<PostAddressResponse>({
      method: 'POST',
      url: '/api/v2/members/me/addresses/',
      data: params,
    })
    .then(r => r.data);
};
